<template>
  <OffCanvas
    :visibility="navVisibility"
    :collapsed="navCollapsed"
    @changed="dispatchSidebarVisibility"
  >
    <SidebarBrand slot="brand" />

    <div slot="account" class="off-canvas__account hide-for-large">
      {{ $auth.user.email }}
    </div>

    <SidebarNavigation slot="navigation" />
    <BazaargahTouchPoint v-if="isBazaargahEnabled" slot="touchpoint" />
  </OffCanvas>
</template>

<script>
import OffCanvas from './OffCanvas';
import BazaargahTouchPoint from './BazaargahTouchPoint';
import SidebarBrand from './SidebarBrand';
import SidebarNavigation from './SidebarNavigation';
import { mapActions, mapGetters } from 'vuex';
import { SIDENAV_VISIBILITY, SIDENAV_COLLAPSED } from '@/store/types';
import FeatureFlags from '@/api/feature-flags';

export default {
  name: 'Sidbar',

  components: {
    OffCanvas,
    BazaargahTouchPoint,
    SidebarBrand,
    SidebarNavigation,
  },

  data() {
    return {
      isBazaargahEnabled: false,
    };
  },

  created() {
    this.fetchBazaargahFeatureFlag();
  },

  computed: {
    ...mapGetters({
      navVisibility: SIDENAV_VISIBILITY,
      navCollapsed: SIDENAV_COLLAPSED,
    }),
  },

  methods: {
    ...mapActions({
      dispatchSidebarVisibility: SIDENAV_VISIBILITY,
    }),

    fetchBazaargahFeatureFlag() {
      return FeatureFlags.getConfig()
        .then(({ isBazaargahEnabled = false }) => {
          this.isBazaargahEnabled = isBazaargahEnabled === true;
        })
        .catch(() => {
          this.isBazaargahEnabled = false;
        });
    },
  },
};
</script>

<style lang="scss">
.off-canvas {
  &__account {
    margin: $lb-side-nav-margin;
    padding: $lb-side-nav-padding;
    font-size: $small-font-size;
  }
}
</style>
